import { Outlet } from "react-router-dom";

const IhioPrescriptionFilling = () => {

    return <Outlet />
}

export default IhioPrescriptionFilling;